import { customerProjects } from "../endpoints";
import useFetch from "../hooks/useFetch";
import { useEffect, useState } from "react";
// import Project from "../components/Projects/Project";

interface data {
  project: string;
  projectId: string;
  refrence: string;
  methode: string;
  budget: string;
  spent: string;
  percentageused: string;
  km: string;
  kmprice: string;
  costs: string;
  status: string;
  factuur: string;
  active: boolean;
  creation: string;
}

interface Props {
  name: string;
}

const CustomerProjectsLayout = ({ name }: Props) => {
  // const [companyName, setCompanyName] = useState("");
  const [showActive, setShowActive] = useState(true);
  const endpoint = customerProjects;
  console.log(name);
  const { data, loading } = useFetch<data>(
    endpoint,
    name ? { companyName: name } : undefined
  );
  console.log(data);

  // useEffect(() => {
  //   const path = window.location.pathname;
  //   const pathParts = path.split("/projects/");

  //   if (pathParts.length > 1) {
  //     const companyNameFromUrl = decodeURIComponent(pathParts[1]);
  //     setCompanyName(companyNameFromUrl);
  //   } else {
  //     console.error("Company name not found in URL");
  //   }
  // }, []);

  // Filter data based on toggle state
  const filteredProjects = data
    ? data.filter((project) => (showActive ? project.active : !project.active))
    : [];

  return (
    <div className="overflow-hidden w-full">
      {/* Header */}
      <div>
        <div className="flex justify-between">
          {/* Header Text */}
          <div className="w-full">
            <div className="flex flex-col w-[100%] sm:flex-row sm:justify-between sm:items-center">
              <h1 className="font-bold text-3xl sm:text-4xl">
                {loading ? (
                  <span className="text-gray-400">Projecten laden...</span>
                ) : (
                  `Projecten (${name})`
                )}
              </h1>

              {/* Toggle Switch */}
              <select
                className="ml-auto rounded-xl border py-2"
                onChange={() => setShowActive(!showActive)}
              >
                <option value="">Actief</option>
                <option value="">Gearchiveerd</option>
              </select>
            </div>

            <p className="mt-4">
              {loading ? (
                <span className="text-gray-400">
                  Een moment geduld, de gegevens worden geladen.
                </span>
              ) : (
                `Hier een overzicht van ${
                  showActive ? "actieve" : "gearchiveerde"
                } projecten van ${name}`
              )}
            </p>
          </div>
        </div>

        {/* Data Table */}
        <div className="p-8 bg-white rounded-xl mt-6 w-full overflow-auto">
          <div className="w-full text-gray-600 flex text-sm p-2 border-b-2">
            <b className="w-[19%] text-left">Project</b>
            <b className="w-[10%] text-center">Nummer</b>
            <b className="w-[12%] text-center">Methode</b>
            <b className="w-[12%] text-center">Aanmaak</b>
            {/* <b className="w-[6%] text-center">Budget</b>
            <b className="w-[6%] text-center">Uitgaven</b>
            <b className="w-[7%] text-center">Uitgaven%</b>
            <b className="w-[5%] text-center">KM</b>
            <b className="w-[5%] text-center">kosten</b>
            <b className="w-[6%] text-center">status</b>
            <b className="w-[7%] text-center">facstatus</b> */}
            <b className="w-[13%] text-center"></b>
          </div>

          {/* {filteredProjects.length > 0
            ? filteredProjects.map((project, index) => (
                <Project
                  key={index}
                  project={project.project}
                  id={project.projectId}
                  refrence={project.refrence}
                  methode={project.methode}
                  budget={project.budget}
                  spent={project.spent}
                  percentageused={project.percentageused}
                  km={project.km}
                  kmprice={project.kmprice}
                  costs={project.costs}
                  status={project.status}
                  factuur={project.factuur}
                  // creation={project.creation}
                />
              ))
            : !loading && (
                <div className="text-center py-8 text-gray-500">
                  {showActive
                    ? "Geen actieve projecten gevonden"
                    : "Geen inactieve projecten gevonden"}
                </div>
              )} */}
        </div>
      </div>
    </div>
  );
};

export default CustomerProjectsLayout;
